import { NewListItem } from 'src/apis/ListsAPI';

export const serialiseVendorListItem = (vendorId: number, note?: string): NewListItem => ({
    content_type: 'VENDOR',
    object_id: vendorId.toString(),
    note,
});
